import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class AlertService {

    constructor(private router: Router) {

    }

    Exitoso(mensaje: string): any {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: 'success',
            title: 'El ' + mensaje + ' se guardo con exito'
        });
    }

    ExitosoGeneral(mensaje: string): any {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: 'success',
            title:  mensaje
        });
    }

    ExitosoActualizar(mensaje: string): any {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: 'success',
            title: 'El ' + mensaje + ' se actualizo con exito.'
        });
    }

    ExitosoEliminar(mensaje: string): any {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: 'success',
            title: 'El ' + mensaje + ' se elimino con exito.'
        });
    }

    Error(mensaje: string): any {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: 'error',
            title: mensaje
        });
    }

    Advertencia(mensaje: string): any {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            iconColor: '#ff1e2d',
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: 'warning',
            title: mensaje
        });
    }

    Informativo(mensaje: string): any {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: 'info',
            title: mensaje
        });
    }
    /* Notificaciones grandes */
    Confirmacion(mensaje: string): any {
        Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
       
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          )
        }
      })
    }

    WarniginBig(mensaje: string): any {
        Swal.fire({
            text: mensaje,
            icon: 'warning',
            iconColor: '#ff1e2d',
            confirmButtonColor: "#ff1e2d", 
            confirmButtonText: 'Aceptar',
            customClass: {
                popup : 'my-popup-class', 
                confirmButton: 'class-btn-confirm-modal',
            }
        })
    }
    WarniginBigConfirmation(mensaje: string): any {
        const result = Swal.fire({
            text: mensaje,
            icon: 'warning',
            iconColor: '#ff1e2d',
            confirmButtonColor: "#ff1e2d", 
            confirmButtonText: 'Aceptar',
            customClass: {
                popup : 'my-popup-class', 
                confirmButton: 'class-btn-confirm-modal',
            },
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                return true;            
            } else {
                return false;
            }
          });

          return result
    }

    WarniginBigReload(mensaje: string, flag: string): any {
        Swal.fire({
            text: mensaje,
            icon: 'error',
            iconColor: '#ff1e2d',
            confirmButtonColor: "#ff1e2d", 
            confirmButtonText: 'Aceptar',
            customClass: {
                popup : 'my-popup-class', 
                confirmButton: 'class-btn-confirm-modal',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload();
            }
          })
    }

    ConfirmationInfoAction(titulo: any, mensaje: any): Promise<boolean> {
       const algo = Swal.fire({
            title: titulo,
            text: mensaje,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'Aceptar',
            iconColor: '#66182A',
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
                popup : 'my-popup-class', 
                confirmButton: 'class-btn-confirm-modal',
            }
          }).then((result) => {
            if (result.isConfirmed) {
                return true;            
            } else {
                return false;
            }
          });

          return algo;
    }
}